<template>
    <section class="experience">
        <h3 class="mb-8">Métiers occupés ou en préparation :</h3>

        <div class="flex items-center gap-3 mb-8">
            <vs-button
                v-if="canUpdate()"
                id="addTraining"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                @click="createResource()"
            >
                Ajouter un métier
            </vs-button>
            <vs-button
                v-if="isEvaluable.length && canUpdate() && planAllow('eval-tiers-croise')"
                id="inviteTiers"
                color="primary"
                type="border"
                @click="inviteTiers"
            >
                Inviter un tiers à évaluer
            </vs-button>

            <div v-else-if="!planAllow('eval-tiers-croise') && !shouldHideOptions()" title="Votre formule n'inclut pas cette fonctionnalité">
                <vs-button
                    id="inviteTiers"
                    color="primary"
                    type="border"
                    disabled="true"
                >
                    Inviter un tiers à évaluer
                </vs-button>
                <vs-icon class="button-bullet" bg="#FF9B3A" round >
                    <CrownIcon style="width: 16px; height: 16px; padding: 3px"/>
                </vs-icon>
            </div>

            <feather-icon 
                icon="SettingsIcon" 
                class="option cursor-pointer opaver"
                @click="showOptions = true"
            />
        </div>

        <DialogPrompt
            :active.sync="showOptions"
            title="Ordonner les métiers en cours"
            cancel-text="Annuler"
            accept-text="Enregistrer"
            @cancel="showOptions = false"
            @close="showOptions = false"
            @accept="closeDialogOrderHandle()"
        >
            <Draggable 
                :data="currentOrderedItems"
                :table="{
                    columns: [
                        { label: 'Ordre', name: 'order' },
                        { label: 'Nom', name: 'title' }
                    ]
                }"
                @updated="updatedOrder = $event"
            />

        </DialogPrompt>

        <DialogPrompt
            :active.sync="showPopup"
            :title="getDataPrompt.title"
            cancel-text="Annuler"
            accept-text="Enregistrer"
            :button-accept="getDataPrompt.btnAccept"
            :is-valid="!hasError"
            @cancel="resetResource"
            @close="resetResource"
            @accept="storeResource"
        >
            <div class="con-exemple-prompt">
                <vs-row class="mt-5 mb-8">
                    <vs-col>
                        <vs-radio 
                            v-model="occupationCategorie" 
                            vs-value="0"
                            :disabled="this.formType != 'create'"
                            @click="resetResource()"
                        >
                            Grille
                        </vs-radio>
                        <vs-radio 
                            v-model="occupationCategorie" 
                            vs-name="experienceType" 
                            vs-value="1"
                            :disabled="this.formType != 'create'"
                            @click="resetResource()"
                        >
                            Métier Myskilliz
                        </vs-radio>
                        <vs-radio 
                            v-model="occupationCategorie" 
                            vs-name="experienceType" 
                            vs-value="2" 
                            class="ml-5"
                            :disabled="this.formType != 'create'"
                            @click="resetResource()"
                        >
                            Autre expérience
                        </vs-radio>
                    </vs-col>
                </vs-row>

                <div
                    v-if="occupationCategorie == occupationCategories.GRID"
                    class="vx-row mb-6"
                >
                    <div class="vx-col w-full mb-5">
                        <b>Ajouter une grille sur le parcours</b>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Métier* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <Multiselect
                            v-model="resource.grid"
                            name="experienceTypes"
                            :options="grids.data"
                            :multiple="false"
                            :group-select="false"
                            placeholder="Recherche ..."
                            group-label="group"
                            group-values="items"
                            track-by="id"
                            label="title"
                            select-label
                            selected-label
                            deselect-label
                            :loading="grids.loading"
                        >
                            <span slot="noResult">Aucun résultat.</span>
                        </Multiselect>
                    </div>
                </div>
                
                <div
                    v-if="(this.formType == 'create' || resource.occupation) && occupationCategorie == occupationCategories.MYSKILLIZ"
                    class="vx-row mb-6"
                >
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Métier déjà existant :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <Multiselect
                            v-if="occupations.data.length > 0"
                            v-model="resource.occupation"
                            name="occupationTitle"
                            :options="occupations.data"
                            :multiple="false"
                            group-label="group"
                            group-values="items"
                            placeholder="Recherche ..."
                            track-by="id"
                            label="title"
                            select-label
                            selected-label
                            deselect-label
                            :loading="occupations.loading"
                        >
                            <span slot="noResult">Aucun résultat.</span>
                        </Multiselect>
                    </div>
                </div>
                <div v-if="occupationCategorie == occupationCategories.OTHER">
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>Libellé du métier* :</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input
                                v-model="resource.title"
                                name="title"
                                class="w-full"
                            />
                        </div>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Dates :</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-input
                            label="Début*"
                            type="date"
                            v-model="resource.start_date"
                            name="start_date"
                            class="w-full"
                        />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-input
                            :label="`Fin${occupationCategorie == occupationCategories.OTHER ? '*' : ''}`"
                            type="date"
                            v-model="resource.end_date"
                            name="end_date"
                            class="w-full"
                        />
                    </div>
                </div>
                <!-- <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Date de fin </span><span v-if="!resource.occupation">*</span><span>:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            type="date"
                            v-model="resource.end_date"
                            name="end_date"
                            class="w-full"
                            description-text="Un métier est évaluable (y compris par un tiers) et auto-évaluable jusqu'à sa date de fin"
                        />
                    </div>
                </div> -->
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span style="float: left;line-height: 26px;">
                            Pièce jointe &nbsp;
                        </span>
                        <vs-chip v-if="!documentLicence" color="secondary">
                            <b>Gratuit jusqu'à {{ postMaxSizePerPerson }} Mo</b>
                        </vs-chip>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <template v-if="resource.doc_path">
                            <template v-for="(doc_path, index) in resource.doc_path.split(';')">
                                <div class="vx-row mb-3">
                                    <div
                                        class="inline mr-1 float-left cursor-pointer"
                                    >
                                        <a @click.prevent="download(doc_path)">{{ doc_path.split('/').pop() }}</a>
                                    </div>
                                    <vs-button
                                        :id="'deleteDoc_Occ_' + doc_path"
                                        color="primary"
                                        type="border"
                                        size="small"
                                        icon-pack="feather"
                                        icon="icon-trash"
                                        @click="removeDocPath(resource, doc_path)"
                                        style="display: inline; margin-top: -0.5rem;"
                                    />
                                </div>
                            </template>
                        </template>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input
                                type="file"
                                multiple
                                :accept="acceptExtensions('all')"
                                name="doc_path"
                                class="w-full"
                                @change="selectFile"
                                :danger="this.fileError.message"
                                :danger-text="this.fileError.message"
                            />
                        </div>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Visible dans l'export :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full mb-2">
                        <vs-checkbox
                            class="w-full"
                            v-model="resource.is_exportable"
                            name="isExportable"
                        ></vs-checkbox>
                    </div>
                </div>
            </div>
        </DialogPrompt>

        <DialogPrompt
            :active.sync="showPopupFullStorage"
            title="Votre espace de stockage est plein"
            cancel-text="Annuler"
            accept-text="OK"
            @close="showPopupFullStorage = false"
            @accept="showPopupFullStorage = false"
        >
            <div class="con-exemple-prompt">
                <p>{{ popupFullStorageMessage }}</p>
            </div>
        </DialogPrompt>

        <vs-table
            :sst="true"
            @sort="eventSortByCol"
            :data="orderedItems"
            no-data-text="Aucune donnée à afficher"
            style="width:100%;"
        >
            <template slot="thead">
                <vs-th>
                    <Sort name="title" @sort="eventSortByCol">Libellé</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="start_date" @sort="eventSortByCol">Date de début</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="end_date" @sort="eventSortByCol">Date de fin</Sort>
                </vs-th>
                <vs-th>
                    Document
                </vs-th>
                <vs-th>
                    <Sort name="is_exportable" @sort="eventSortByCol">Export</Sort>
                </vs-th>
                <vs-th v-if="canUpdate()">
                    Actions
                </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr
                    v-for="(item, indextr) in data"
                    :key="indextr"
                    :data="item"
                >
                    <vs-td :data="item.title">
                        {{ item.title }}
                    </vs-td>
                    <vs-td :data="item.start_date">
                        {{ item.start_date || "-" | date }}
                    </vs-td>
                    <vs-td :data="item.end_date">
                        {{ item.end_date || "-" | date }}
                    </vs-td>
                    <vs-td v-if="item.doc_path">
                        <template v-for="(doc_path, index) in item.doc_path.split(';')">
                            <i
                                v-if="doc_path"
                                :key="'file_'+doc_path+index"
                                :class="'ml-1 fa fa-file'+(doc_path.split('.').pop() === 'pdf' ? '-pdf' : '')"
                                style="font-size: 2rem; color: rgba(var(--vs-primary),1)"
                                @click="download(doc_path)"
                                v-tooltip="{
                                    content: doc_path.split('/').pop(),
                                    placement: 'top-start',
                                    classes: ['occ-description']
                                }"
                            ></i>
                        </template>
                    </vs-td>
                    <vs-td v-else></vs-td>
                    <vs-td>
                        <feather-icon
                            v-if="item.is_exportable"
                            icon="CheckSquareIcon"
                            svg-classes="h-6 w-6 icon-info vs-icon-primary"
                            class="ml-2"
                            v-tooltip="'Export autorisé'"
                            @click="exportableClickHandle(item, false)"
                        />
                        <feather-icon
                            v-else
                            icon="SquareIcon"
                            svg-classes="h-6 w-6 icon-info"
                            class="ml-2"
                            @click="exportableClickHandle(item, true)"
                        />
                    </vs-td>
                    <vs-td v-if="canUpdate()">
                        <vs-button
                            v-if="can('update', 'employees')"
                            :id="'modifyJob_' + indextr"
                            v-tooltip="'Modifier'"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-edit"
                            @click="updateResource(item)"
                        />
                        <vs-button
                            v-if="can('update', 'employees')"
                            :id="'deleteJob_' + indextr"
                            v-tooltip="'Supprimer'"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-trash"
                            style="margin-left: 1rem;"
                            @click="deleteResource(item)"
                        />
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </section>
</template>

<script>
import Multiselect from "vue-multiselect";
//import Datepicker from "vuejs-datepicker";
import { fr } from "vuejs-datepicker/dist/locale";
import { format } from 'date-fns'
import CrownIcon from '@components/svg/CrownIcon';
export default {
    name: "EmployeeOccupations",
    components: {
        Multiselect,
        //Datepicker,
        CrownIcon
    },
    props: {
        api: {
            type: String
        },
        employee: {
            required: false,
            type: Object
        },
        documentLicence: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            fr: fr,
            log: console.log,
            resource: {},
            showPopup: false,
            showOptions: false,
            showPopupFullStorage: false,
            popupFullStorageMessage: null,
            loading: true,
            formError: true,
            formType: "create",
            occupations: {
                data: [],
                loading: true
            },
            grids: {
                data: [],
                loading: false
            },
            prompt: {
                show: {
                    title: "Consulter un métier",
                    btnAccept: "false"
                },
                create: {
                    title: "Ajouter un métier",
                    btnAccept: "filled"
                },
                update: {
                    title: "Modifier un métier",
                    btnAccept: "filled"
                }
            },
            file: null,
            files: null,
            fileError: {
                message: null,
            },
            postMaxSizePerPerson: process.env.MIX_TOTAL_SPACE_WITHOUT_LICENCE,
            maxFileSize: process.env.MIX_PHP_MAX_FILESIZE,
            occupationCategories: {
                GRID: 0,
                MYSKILLIZ: 1,
                OTHER: 2
            },
            occupationCategorie: null,
            updatedOrder: []
        };
    },
    watch: {},
    computed: {
        hasError() {
            let error = true;

            if (this.resource.occupation || this.resource.grid) {
                error = !this.resource.start_date;
            } else {
                error =
                    !this.resource.title ||
                    !this.resource.start_date ||
                    !this.resource.end_date;
            }

            return error;
        },
        isEvaluable() {
            // Seuls les métiers en cours sont proposés dans la form d'invitation
            let current = [];
            if (!this.loading) {
                this.items.forEach(occupation => {
                    if (occupation.end_date == null || (new Date(occupation.end_date)).getTime() > Date.now()) {
                        current.push(occupation)
                    }
                });
            }
            return current;
        },
        orderedItems() {
            if (!this.items.length) return []

            return this.items.map(item => {
                item.order = item.order == 0 ? 9999 : item.order;
                return item;
            }).sort((a, b) => a.order > b.order ? 1 : -1)
        },
        currentOrderedItems() {
            return _.cloneDeep(this.orderedItems).filter(i => !i.end_date).map((item, i) => {
                item.order = i + 1
                return item
            })
        }
    },
    methods: {
        selectFile(e) {
            this.files = null
            this.fileError.message = null
            if (e.target.files.length !== 0) {
                Array.from(e.target.files).forEach(file => {
                    if (file.size >= this.maxFileSize*1024*1024) {
                        this.fileError.message = 'La taille du fichier de '+this.getReadableFileSizeString(file.size)+' est supérieure à la valeur autorisée de '+this.maxFileSize+' Mo'
                    }
                    else {
                        this.file = file
                        if (!this.files) this.files = []
                        this.files.push(file)
                    }
                })
            }
        },
        removeDocPath(resource, doc_path) {
            this.$swal({
                title: `Attention`,
                html: `Êtes-vous sûr de vouloir supprimer cet élément ?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Je confirme',
                cancelButtonText: 'Non'
            }).then(response => {
                if (response.value) {
                    let jobClass = 'EmployeeOccupation'
                    if (!resource.occupation) jobClass = 'Experience'
                    window
                        .axios({
                            method: "post",
                            url: "/api/gestion/employees/career/doc/delete",
                            params: { path: doc_path, class: jobClass, id: resource.pivot_id || resource.id },
                        })
                        .then(response => {
                            this.loadItems().then(() => {
                                this.$emit('change')
                                this.setResource(this.items.find(i => i.id === resource.id))
                            })
                        })
                        .catch(err => {
                            this.notifyError(err, `Une erreur est survenue`, true);
                        });
                }
            })
        },
        download(path) {
            window
                .axios({
                    method: "get",
                    url: "/api/gestion/employees/career/doc",
                    params: { path: path },
                    responseType: 'blob', // Indique que la réponse sera un fichier
                })
                .then(response => {
                    console.log('Download DONE !!')
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', path.split('/').pop()); // Spécifie le nom du fichier à télécharger
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(async (err) => {
                    let errorResponse = await err.response.data.text();
                    const errorObj = JSON.parse(errorResponse);
                    err.response.status = err.code
                    err.message = errorObj.message
                    this.notifyError(err, `Une erreur est survenue`, true);
                });
        },
        loadOccupations() {
            this.occupations.loading = true;

            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/occupations",
                    params: { perpage: 999, sortBy: {"title": "asc"}, include: []}
                })
                .then(response => {
                    this.occupations.data = this.groupForMultiselect(response.data.data, ['type']);
                    this.occupations.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        loadGrids() {
            
            this.grids.loading = true;

            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/grids",
                    params: {
                        perpage: 999,
                        include: ['sector'],
                    }
                })
                .then(response => {
                    this.groupForMultiselect()
                    this.grids.data = this.groupForMultiselect(response.data.data, ['sector.title']);
                    this.grids.loading = false;
                })
                .catch(err => {
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        canUpdate() {
            return this.canMulti("update", "employees", this.employee.services.map(s => s.id));
        },

        createResource() {
            this.resourceReadonly = false;
            this.resetResource();
            this.formType = "create";
            this.showPopup = true;
        },

        updateResource(resource) {
            this.resourceReadonly = false;
            this.resetResource();
            this.setResource(resource);
            this.formType = "update";
            
            if (this.resource.occupation) {
                this.occupationCategorie = this.occupationCategories.MYSKILLIZ
            } else if (this.resource.grid) {
                this.occupationCategorie = this.occupationCategories.GRID
            } else {
                this.occupationCategorie = this.occupationCategories.OTHER
            }

            this.showPopup = true;
        },

        exportableClickHandle(resource, exportable) {
            resource.is_exportable = exportable;
            this.setResource(resource);
            this.formType = "update";
            this.storeResource();
        },

        storeResource() {
            let data = JSON.parse(JSON.stringify(this.resource));
            data.occupation_id = this.resource.occupation?.id;
            data.grid_id = this.resource.grid?.id;
            data.end_date = this.resource.end_date ? this.getDate(this.resource.end_date) : this.resource.end_date;
            data.files = this.files
            data.is_exportable = data.is_exportable ? 'true' : 'false'

            delete data.occupation
            delete data.grid

            this.localLoading()
            if (data.id) {
                this.apiUpdate(
                    data,
                    this.resource.id,
                    resp => {
                        if (!resp.data.availableSizeValidation) {
                            this.showPopupFullStorage = true
                            this.popupFullStorageMessage = resp.data.availableSizeValidationMessages
                        }
                        this.loadItems()
                        this.$emit('change')
                        this.endLocalLoading()
                        this.files = null
                    },
                    (err) => {
                        this.files = null
                        this.showPopup = true
                        this.endLocalLoading()
                    },
                    {'Content-Type': 'multipart/form-data'}
                );
            } else {
                this.apiCreate(
                    data,
                    resp => {
                        if (!resp.data.availableSizeValidation) {
                            this.showPopupFullStorage = true
                            this.popupFullStorageMessage = resp.data.availableSizeValidationMessages
                        }
                        this.loadItems()
                        this.$emit('change')
                        this.endLocalLoading()
                        this.files = null
                    },
                    (err) => {
                        this.files = null
                        this.showPopup = true
                        this.endLocalLoading()
                    },
                    {'Content-Type': 'multipart/form-data'}
                );
            }
            this.files = null
        },

        apiSpecificDelete(url, params, callback) {
            this.$swal({
                title: `Êtes-vous sûr de vouloir supprimer cet élément ?`,
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'Annuler'
            }).then(async result => {
                if (result.value) {
                    window.axios({
                        method: 'delete',
                        url: url,
                        params: params
                    })
                        .then(response => {

                            if (response.status === 204) {
                                this.notifySuccess('Élement supprimé avec succès !')
                            } else {
                                this.notifyError('Erreur', `Une erreur est survenue lors de la suppression`)
                            }

                            if (callback) {
                                callback(response);
                            }
                        })
                        .catch((err) => {
                            this.notifyError(err, `Une erreur est survenue`)
                        })
                }
            })
        },

        deleteResource(resource) {

            let params, url

            if (!!resource.grid || !!resource.occupation) {
                params = {type: resource.occupation ? 'occupation' : 'grid'}
                url = `/api/gestion/employees/${this.employee.id}/occupations/${resource.id}`
            } else {
                params = {}
                url = `/api/gestion/employees/${this.employee.id}/experiences/${resource.id}`
            }

            this.apiSpecificDelete(url, params, () => {
                this.loadItems()
                this.$emit('change')
            })
        },

        setResource(data) {
            let dataTemp = JSON.parse(JSON.stringify(data));
            dataTemp.start_date = this.getDate(dataTemp.start_date);
            dataTemp.end_date = dataTemp.end_date ? this.getDate(dataTemp.end_date) : dataTemp.end_date;
            this.resource = dataTemp;
        },

        resetResource() {
            this.resource = {
                occupation: null,
                is_exportable: true,
                start_date: format(new Date(), "yyyy-MM-dd"),
                end_date: null,
                title: null,
                doc_path: null,
            };
        },
        inviteTiers() {
            this.$emit('invite-tiers');
        },

        closeDialogOrderHandle() {
            this.showOptions = false;
            const items = this.updatedOrder.length > 0 ? this.updatedOrder : this.currentOrderedItems

            this.updatedOrderHandle(items)
        },

        updatedOrderHandle(items) {
            let toUpdate = [];
            items.forEach((item, i) => {
                this.setResource(item)
                toUpdate.push(this.storeResource());
            });

            this.resetResource();

            Promise.all(toUpdate).then(() => {
                this.notifySuccess('Succès', 'Ordre modifié avec succès !')
                this.orderChanged = false;
                this.dragging = null;
                this.loadItems();
            })
        }
    },
    created() {
        this.apiParams = {
            sortBy: {"end_date": "desc"}
        };
        this.resetResource();
        this.loadItems();
        this.loadOccupations();
        this.loadGrids();

        this.occupationCategorie = this.occupationCategories.MYSKILLIZ;
    }
};
</script>

<style lang="scss" scoped>
::v-deep .con-text-validation {
    font-size: 0.8rem;
}
</style>
